<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <div class="flex items-center justify-between gap-4 mb-4">
                <p class="text-lg font-medium">{{ branch.title }} University Marking</p>
            </div>

            <breeze-table :fields="fields" :items="markings" :canView="true">
                <template #course="data">
                    {{ data.item.course.title }}
                </template>
                <template #course_year="data">
                    {{ data.item.course_year.title }}
                </template>
                <template #semester="data">
                    {{ data.item.semester.title }}
                </template>
                <template #max_marks="data">
                    Internal {{ data.item.internal_max_marks }} / External {{ data.item.external_max_marks }}
                </template>
                <template #action="data">
                    <button-link :href="route('internal.university-marking.show', [branch.id, data.item.id])">
                        Add Internal Marks
                    </button-link>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import ButtonLink from '@/Components/ButtonLink'
import BreezeTable from '@/Components/Table'

export default {
    components: {
        Internal,
        ButtonLink,
        BreezeTable,
    },
    props: ['branch', 'markings'],
    data() {
        return {
            fields: [
                {'key': 'course', 'label': 'Course'},
                {'key': 'course_year', 'label': 'Course Year'},
                {'key': 'semester', 'label': 'Semester'},
                {'key': 'subjects_count', 'label': 'Subjects'},
                {'key': 'max_marks', 'label': 'Max Marks'},
                {'key': 'action', 'label': 'Action'},
            ],
        }
    },
}
</script>
